
























import Vue, { PropType } from "vue";
import { TurntableItem } from "../models";
export default Vue.extend({
	model: {
		prop: "items"
	},
	props: {
		items: { type: Array as PropType<TurntableItem[]> }
	},
	methods: {
		add() {
			this.items.push({ content: "", weight: 1 });
		},
		del(idx: number) {
			if (this.items.length > 1) this.items.splice(idx, 1);
		}
	}
});
